import { NgZone } from '@angular/core';

export class Timer {
    private timerId = 0;
    private start = 0;
    private remaining: number;

    constructor(
        private readonly callback: () => void,
        private readonly delay: number,
        private readonly ngZone: NgZone
    ) {
        this.remaining = delay;
        this.resume();
    }

    public pause(): void {
        window.clearTimeout(this.timerId);
        this.remaining -= Date.now() - this.start;
    }

    public resume(minimalRemaining: number = 0): void {
        this.start = Date.now();
        window.clearTimeout(this.timerId);
        if (minimalRemaining > this.remaining) {
            this.remaining = minimalRemaining;
        }
        this.ngZone.runOutsideAngular(() => {
            this.timerId = window.setTimeout(this.callbackFn.bind(this), this.remaining);
        });
    }

    private callbackFn(): void {
        this.ngZone.run(() => {
            this.callback();
        });
    }

    public stop(): void {
        window.clearTimeout(this.timerId);
        this.remaining = 0;
    }
}
